<template>
    <div>
        <div class="table-search ms-3 table-search-subscriptions">
            <div class="form-search d-flex">
            <input id="users-search-input" type="text"
                v-model="searchValue"
                @input="getSearchValue()"
                class="form-control-search main-form-control @error('search') is-invalid @enderror"
                name="search" placeholder="Search by Full Name">
            <img src="/images/search.png" alt="search"
                class="img-fluid search-icon">
            <i class="icon-help ms-2 fas fa-fw fa-question-circle cursor-pointer"
                title="" data-bs-container="body"
                data-bs-toggle="popover" data-bs-placement="top"
                data-bs-content="Id, First Name, Last Name, Phone Number, Email Address"
                data-bs-original-title="Search fields" aria-describedby="popover"></i>
            </div>
        </div>
        <download-excel
            :data="subscriptions"
            :fields="total_trial_period"
            type="csv">
            <b-button class="export-btn">Export to CSV</b-button>
            </download-excel>
        <b-table
            class="table-responsive"
            :items="subscriptions"
            :fields="fieldsSubscriptions"
        >
        <template v-slot:cell(grant_subscription_period)="{item}">
            <div data-bs-toggle="tooltip" data-bs-placement="top" title="Paid Subscription">
                <button
                    @click="getUserId(item.id)"
                    v-b-modal.modal-grant-subscription
                    type="button"
                    class="btn mb-1 btn-danger js-open-confirmation"
                >Grant Paid Subscription
                </button>
            </div>
        </template>
        <template v-slot:cell(extend_trial_period)="{item}">
          <div data-bs-toggle="tooltip" data-bs-placement="top" title="Delete User">
            <button
                @click="getUserId(item.id)"
                v-b-modal.modal-resume-date
                type="button"
                class="btn mb-1 btn-danger js-open-confirmation"
            >Extend trial period
            </button>
          </div>
        </template>
        <template v-slot:cell(cancel_subscription)="{item}">
          <div data-bs-toggle="tooltip" data-bs-placement="top">
            <button
                @click="getUserId(item.id)"
                v-b-modal.cancel-modal
                class="btn mb-1 btn-danger js-open-confirmation"
            >Cancel Subscription
            </button>
          </div>
        </template>
        </b-table>
        <b-modal
            no-enforce-focus
            id="modal-resume-date"
            centered
            title="Until when should the subscription be extended?"
        >
            <div class="row mb-12">
                <label for="resume_date" class="main-text-bold pb-3 pt-3 px-0">Resume Date</label>
                <input
                    v-model="resume_date"
                    name="resume_date"
                    type="date"
                    id="date"
                    required
                    class="form-control main-text-input js-form-element datepicker-bid mb-1">
            </div>
            <template #modal-footer>
                <div class="w-100">
                <b-button
                    variant="primary"
                    size="sm"
                    class="text-align-end"
                    @click="submitResumeDate"
                >
                    Submit
                </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal
            no-enforce-focus
            id="cancel-modal"
            centered
            title="By clicking on the button you cancel the subscription!"
        >
            <template #modal-footer>
                <div class="w-100 text-align-end">
                <b-button
                    variant="primary"
                    size="sm"
                    @click="cancelSubscription"
                >
                    Submit
                </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal
            no-enforce-focus
            id="modal-grant-subscription"
            centered
            title="Until when should the subscription be extended?"
        >
            <div class="row mb-12">
                <label for="resume_date" class="main-text-bold pb-3 pt-3 px-0">Select Type Of User</label>
                <b-form-select v-model="selectedRole" :options="roleOptions"
                               name ="user-role"
                               required
                               class="form-control main-text-input js-form-element datepicker-bid mb-1">

                </b-form-select>
            </div>
            <div v-if="selectedRole === 'venue'" class="row mb-12">
                <label for="subscription_type" class="main-text-bold pb-3 pt-3 px-0">Subscription Type</label>
                <b-form-select v-model="subscriptionType" :options="venueSubscriptions" name="subscription-type" required class="form-control main-text-input js-form-element datepicker-bid mb-1">
                </b-form-select>
            </div>
            <div v-if="selectedRole === 'artist'" class="row mb-12">
                <label for="subscription_type" class="main-text-bold pb-3 pt-3 px-0">Subscription Type</label>
                <b-form-select v-model="subscriptionType" :options="artistSubscriptions" name="subscription-type" required class="form-control main-text-input js-form-element datepicker-bid mb-1">
                </b-form-select>
            </div>
            <div class="row mb-12">
                <label for="resume_date" class="main-text-bold pb-3 pt-3 px-0">Trial Date</label>
                <input
                    v-model="trialPeriod"
                    name="grant_subscription"
                    type="date"
                    id="date"
                    required
                    class="form-control main-text-input js-form-element datepicker-bid mb-1">
            </div>
            <template #modal-footer>
                <div class="w-100">
                    <b-button
                        variant="primary"
                        size="sm"
                        class="text-align-end"
                        @click="grantSubscription"
                    >
                        Submit
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'SubscriptionsAdminTable',
    data: () => ({
        userId: '',
        resume_date: '',
        searchValue: '',
        subscriptions: '',
        subscriptionType: '',
        fieldsSubscriptions: ['id', 'full_name', 'email', 'role', 'subscription_plan', 'subscription_status',
            'start', 'trial_until', 'total_trial_period', 'grant_subscription_period', 'extend_trial_period', 'cancel_subscription'],
        csvFields: {
            Full_Name: 'full_name',
            Email: 'email',
            Role: 'role',
            Subscription_plan: 'subscription_plan',
            Subscription_status: 'subscription_plan',
            Start: 'start',
            Trial_until: 'trial_until',
            Total_trial_period: 'total_trial_period'
        },
        selectedRole: '',
        trialPeriod: 7,
        roleOptions: ['venue', 'artist'],
        venueSubscriptions: ['VenuePro', 'VenueGrowth', 'VenuePremium'],
        artistSubscriptions: ['ArtistPro']
    }),
    methods: {
        async cancelSubscription() {
            await axios.post('/admin/subscriptions/cancel', {
                id: this.userId
            })
            window.location.reload()
        },
        async submitResumeDate() {
            await axios.post('/admin/subscriptions/resume', {
                id: this.userId,
                resume_date: this.resume_date
            })
            window.location.reload()
        },
        getUserId(id) {
            this.userId = id
        },
        async getSearchValue() {
            setTimeout(async () => {
                const response = await axios.post('/admin/subscriptions/search-list', {
                    search: {
                        value: this.searchValue
                    }
                })
                this.subscriptions = response.data
            }, 500)
        },
        async grantSubscription() {
            try {
                if (this.selectedRole) {
                    await axios.post('/admin/subscriptions/grant-subscription', {
                        id: this.userId,
                        role: this.selectedRole,
                        subscription: this.subscriptionType,
                        trialPeriod: this.trialPeriod,
                    })
                }
                window.location.reload()
            } catch (error) {
                console.error('Error granting subscription:', error)
            }
        },
    },
    async created() {
        const result = await axios.get('/admin/subscriptions/list')
        this.subscriptions = result.data.data
    }
}

</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .export-btn {
        margin-left: 1rem;
    }
    .table-search-subscriptions {
        width: 50%;
        margin-bottom: 20px;
    }
</style>
